import { getFileType } from './fileTypeUtils';

export const TEXT_EDIT_EXTENSIONS = [
  'html',
  'htm',
  'txt',
  'json',
  'js',
  'css',
  'md',
  'xml',
  'csv',
  'yml',
  'yaml',
] as const;

const getNormalizedExtension = (fileName = '') => {
  return getFileType('', fileName).toLowerCase();
};

export const isTextEditableExtension = (fileName = '') => {
  const extension = getNormalizedExtension(fileName);
  return TEXT_EDIT_EXTENSIONS.includes(extension as typeof TEXT_EDIT_EXTENSIONS[number]);
};

export const canTextOnlineEdit = (fileName = '', storageType?: string) => {
  return storageType !== 'TEMPORARY' && isTextEditableExtension(fileName);
};
